var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-advanced-search-field',_vm._g({attrs:{"searches":_vm.searches,"attributes":_vm.attributes,"pending":_vm.pending,"allow-or":_vm.allowOr,"alarm-pattern":_vm.alarmPattern,"with-history":_vm.withHistory},model:{value:(_vm.rules),callback:function ($$v) {_vm.rules=$$v},expression:"rules"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }